import EstimationIndex from "../../pages/Estimations/Estimation"
import EditEstimation from "../../pages/Estimations/Estimation/edit"
import ViewEstimations from "../../pages/Estimations/Estimation/view"
import ProjectManagement from "../../pages/ProjectManagement"
import ProjectOverview from "../../pages/ProjectManagement/overview"
import Customer from "../../pages/ProjectManagement/customer"
import EditCustomer from "../../pages/ProjectManagement/customer/edit"
import ProjectMasterDashboard from "../../pages/ProjectManagement/projectDashboard"
import ProjectDashboardIndex from "../../pages/ProjectManagement/projectDashboard/dashboard"
import FinanceDashboard from "../../pages/ProjectManagement/projectDashboard/financeDashboard"
import HrmsIndex from "../../pages/ProjectManagement/projectDashboard/hrms"
import ProcurementIndex from "../../pages/ProjectManagement/projectDashboard/procurement"
import ProjectManagerProjectDash from "../../pages/ProjectManagement/projectDashboard/projectManagerDashboard"
import ShopKeeperIndex from "../../pages/ProjectManagement/projectDashboard/shopKeeper"
import TimeKeeper from "../../pages/ProjectManagement/projectDashboard/timeKeeper"
import ProjectMaster from "../../pages/ProjectManagement/projectMaster"
import EditProjectMaster from "../../pages/ProjectManagement/projectMaster/edit"
import UpdateWorkProgress from "../../pages/ProjectManagement/projectMaster/updateProgress"

export const projectManagementRoutes = [
  { path: "/project", component: <ProjectManagement /> },
  { path: "/project-overview", component: <ProjectOverview /> },
  { path: "/project-customer", component: <Customer /> },
  { path: "/project-customer/add", component: <EditCustomer /> },
  { path: "/project-customer/edit/:id", component: <EditCustomer /> },
  { path: "/project-master", component: <ProjectMaster /> },
  { path: "/project-master/:action/:id", component: <EditProjectMaster /> },
  { path: "/project-master/add", component: <EditProjectMaster /> },
  { path: "/project-master/work-progress/edit/:id", component: <UpdateWorkProgress /> },
  { path: "/project-master/work-progress/view/:id", component: <UpdateWorkProgress /> },
  // { path: "/project-master/edit/:id" , component: <EditProjectMaster /> },
  { path: "/project-location", component: <ProjectManagement /> },
  { path: "/project-master-dashboard", component: <ProjectMasterDashboard /> },
  { path: "/project-dashboard/:id", component: <ProjectDashboardIndex /> },
  { path: "/project-store-dash/:id", component: <ShopKeeperIndex /> },
  { path: "/project-procurement-dash/:id", component: <ProcurementIndex /> },
  { path: "/project-hrms-dash/:id", component: <HrmsIndex /> },
  { path: "/project-timekeeper-dash/:id", component: <TimeKeeper /> },
  { path: "/project-attendance/:id", component: <TimeKeeper /> },
  { path: `project-finance-dash/:id`, component: <FinanceDashboard /> },
  {
    path: `project-manager-dash/:id`,
    component: <ProjectManagerProjectDash />,
  },
  {
    path: `project-budget`,
    component: <EstimationIndex />,
  },
  {
    path: `project-budget/add`,
    component: <EditEstimation />,
  },
  {
    path: `project-budget/edit/:id`,
    component: <EditEstimation />,
  },
  {
    path: `project-edit/:id`,
    component: <EditEstimation />,
  },
  {
    path: `project-budget/view/:id`,
    component: <ViewEstimations />,
  },
]
